import { useState, useRef } from 'react'
import { ChevronDown, MoveLeft } from 'lucide-react'
import './CourseLanding.css'
import logo from '../../assets/images/storiesLogo.svg'
import heroBg from '../../assets/images/lending/Rectangle 3.png'
import navFounder from '../../assets/images/lending/Group 2765.png'
import navMission from '../../assets/images/lending/Group 2766.png'
import navAudience from '../../assets/images/lending/Group 2767.png'
import navResults from '../../assets/images/lending/Group 2768.png'
import navProgram from '../../assets/images/lending/Group 2769.png'
import navPricing from '../../assets/images/lending/Group 2770.png'
import navFormat from '../../assets/images/lending/Group 2771.png'
import navFaq from '../../assets/images/lending/Group 2772.png'
import ownerPhoto from '../../assets/images/lending/owner.png'
import logoGray from '../../assets/images/lending/logo666.svg'
import decor1 from '../../assets/images/lending/Mask group.png'
import decor2 from '../../assets/images/lending/Mask group-1.png'
import decor3 from '../../assets/images/lending/Mask group-2.png'
import decor4 from '../../assets/images/lending/Mask group-3.png'
import decor5 from '../../assets/images/lending/Mask group-4.png'
import decor6 from '../../assets/images/lending/Rectangle 147.png'
import decor7 from '../../assets/images/lending/Rectangle 147-1.png'
import decor8 from '../../assets/images/lending/Rectangle 147-2.png'
import decor9 from '../../assets/images/lending/Rectangle 147-3.png'
import decor10 from '../../assets/images/lending/Rectangle 148.png'
import missionPhoto from '../../assets/images/lending/mission.png'
import audience1 from '../../assets/images/lending/Rectangle 135.png'
import audience2 from '../../assets/images/lending/Rectangle 139.png'
import audience3 from '../../assets/images/lending/Rectangle 149.png'
import audience4 from '../../assets/images/lending/Rectangle 137.png'
import audience5 from '../../assets/images/lending/Rectangle 150.png'
import module1 from '../../assets/images/lending/Rectangle 75modules.png'
import module2 from '../../assets/images/lending/Rectangle 103modules.png'
import module3 from '../../assets/images/lending/Rectangle 153modules.png'
import module4 from '../../assets/images/lending/Rectangle 154modules.png'
import module5 from '../../assets/images/lending/Rectangle 155modules.png'
import module6 from '../../assets/images/lending/sgrqerh 1modules.png'
import formatLearning1 from '../../assets/images/lending/formatlearning1.png'
import formatLearning2 from '../../assets/images/lending/formatlearning2.png'
import formatLearning3 from '../../assets/images/lending/formatlearning3.jpg'
import socialSecret from '../../assets/images/secret.png'
import socialConditerka from '../../assets/images/conditerka.png'
import socialWeddingTg from '../../assets/images/lending/Mask group-2.png'
import socialWeddingIg from '../../assets/images/lending/Frame 1336585414.png'
import logoLight from '../../assets/images/logoLight.svg'
interface CourseLandingProps {
  onBuyClick: () => void
}

const NAV_ITEMS = [
  { label: 'О создателе', id: 'founder', image: navFounder },
  { label: 'Миссия', id: 'mission', image: navMission },
  // { label: 'Для кого', id: 'audience', image: navAudience },
  { label: 'Результаты', id: 'results', image: navResults },
  { label: 'Программа\nкурса', id: 'program', image: navProgram },
  { label: 'Тарифы', id: 'pricing', image: navPricing },
  { label: 'Формат\nобучения', id: 'format', image: navFormat },
  { label: 'FQA', id: 'faq', image: navFaq },
]

const DECORS = [
  { title: 'Торт «Нежные банты»', image: decor1 },
  { title: 'Торт «Нежные цветы»', image: decor9 },
  { title: 'Торт «Бусы»', image: decor2 },
  { title: 'Торт «Нежность»', image: decor3 },
  { title: 'Торт «Корейский дизайн»', image: decor4 },
  { title: 'Торт «Итальянский пирог»', image: decor6 },
  { title: 'Торт «Длинный»', image: decor7 },
  { title: 'Торт «Оригами»', image: decor8 },
  { title: 'Торт «Капуста»', image: decor10 },
  { title: 'Торт «Шторы»', image: decor5 },
]

const AUDIENCE_CARDS = [
  {
    title: 'Боитесь,\nчто торт развалится',
    description: 'не доедет или подведёт в самый ответственный момент',
    variant: 'light' as const,
    image: audience1,
    solution:
      'Получите пошаговую систему сборки с правильными опорами и креплениями. После неё вы будете точно знать, как собрать конструкцию, которая выдержит переезд куда угодно',
  },
  {
    title: 'Не уверены в расчётах\nи пропорциях',
    description:
      'боитесь, что торт не влезет в холодильник или не выдержит собственный вес',
    variant: 'dark' as const,
    image: audience2,
    solution:
      'Даём готовые схемы и чертежи для разных форматов, с точными замерами и перерасчётом продуктов. Все пропорции адаптированы под домашний холодильник (кроме бонусного урока)',
  },
  {
    title: 'Сталкиваетесь\nс проблемами',
    description: 'трещины на мастике, перекошенные ярусы, «поплывший» крем',
    variant: 'light' as const,
    image: audience3,
    solution:
      'В курсе мы не просто даём решение, а детально разбираем каждую типичную ошибку: почему появляются трещины, как правильно покрывать торт ганашем и мастикой и выравнивать ярусы.',
  },
  {
    title: 'Хотите красивые свадебные дизайны',
    description:
      'но боитесь за декор или не знаете с какой стороны к нему подойти',
    variant: 'dark' as const,
    image: audience4,
    solution:
      '10 уроков по трендовым дизайнам с пошаговой сборкой и расчётом материалов. Декор будет не только красивым, но и надёжно закреплённым',
  },
  {
    title: 'Упёрлись в потолок',
    description: 'не понимаете, как выйти на новый уровень качества',
    variant: 'light' as const,
    image: audience5,
    solution:
      'Курс построен как полная система: от начинок и сборки до организации заказов, тайминга, упаковки и транспортировки. Это не просто уроки, а готовая база для уверенной работы со свадебными тортами',
  },
]

const MODULES = [
  {
    number: 1,
    title: 'Вводный\nмодуль',
    expandedTitle: 'Вводный модуль',
    description: 'Инвентарь, сборка начинок, расчёт пропорций',
    details: [
      {
        heading: 'Урок 0',
        text: '«Вводная часть, знакомство, поздравление, что пришли на курс, краткий рассказ о преимуществах ниши свадебных тортов»',
      },
      {
        heading: 'Урок 1',
        text: '«Необходимый инвентарь для приготовления и оформления свадебных тортов, информация по холодильнику, подложкам, каркасу и опорам»',
      },
      { heading: 'Урок 2', text: '«Подложка»' },
      { heading: 'Урок 3', text: '«Сборка начинок»' },
      { heading: 'Урок 4', text: '«Пропорции торта + перерасчет начинок»' },
    ],
    variant: 'dark' as const,
    image: module3,
  },
  {
    number: 2,
    title: 'Начинки\nтортов',
    expandedTitle: 'Модуль «Начинки»',
    description: '8 уникальных и стабильных начинок от Pauline Cake',
    details: [
      { heading: 'Урок 1', text: 'торт «Фисташка-Малина»' },
      { heading: 'Урок 2', text: 'торт «Тропический»' },
      { heading: 'Урок 3', text: 'торт «Черный лес»' },
      { heading: 'Урок 4', text: 'торт «Сникерс»' },
      { heading: 'Урок 5', text: 'торт «Ваниль-Ягоды»' },
      { heading: 'Урок 6', text: 'торт «Нутелла»' },
      { heading: 'Урок 7', text: 'торт «Медовик»' },
      { heading: 'Урок 8', text: 'торт «Банан-Карамель»' },
    ],
    variant: 'light' as const,
    image: module6,
  },
  {
    number: 3,
    title: 'Покрытия\nтортов',
    expandedTitle: 'Модуль «Покрытия»',
    description: 'Ганаш, мастика, велюр: нанесение без дефектов',
    details: [
      {
        heading: 'Блок 1',
        text: '«Ганаш»',
        bullets: [
          'Виды и преимущества ганаша;',
          'Пошаговая технология ганаша;',
          'Работа с ганашем;',
          'Частые ошибки при работе с ганашем и их исправление',
        ],
      },
      {
        heading: 'Блок 2',
        text: '«Мастика»',
        bullets: [
          'Виды мастики;',
          'Разница в свойствах и применении мастики;\n– Как работать с мастикой;\n– Как избежать трещин, пузырей и нежелательных складок;\n– Как хранить мастику ',
        ],
      },
      {
        heading: 'Блок 3',
        text: '«Велюр»',
        bullets: [
          'Что из себя представляет + лайфхаки, как не запачкать кухню.',
          'Рецепт велюра, окрашивание;',
          'Как и чем наносить велюр',
        ],
      },
    ],
    variant: 'dark' as const,
    image: module4,
  },
  {
    number: 4,
    title: 'Сборка\nи конструкция',
    expandedTitle: 'Модуль «Конструкция и сборка ярусных тортов»',
    description: 'Сборка фальш-ярусов, живых тортов и гибридов',
    details: [
      {
        heading: 'Блок 1',
        text: '«Фальш-ярусы»',
        bullets: [
          'Принципы выбора и подготовки фальш-ярусов;\n– Сборка торта из фальш-ярусов: фиксация и выравнивание;\n– Покрытие фальш-ярусов: ганаш, крем, мастика;',
        ],
      },
      { heading: 'Блок 2', text: '«Сборка живых тортов»' },
      {
        heading: 'Блок 3',
        text: '«Конструкция»',
        bullets: [
          'Принципы устойчивости и безопасности конструкции',
          'Разные варианты крепления ярусов',
          'Подложки и центральные шпажки',
          'Разметка и установка опор',
          'Сборка гибридного торта + живая вставка в фальш-торте',
          'Чертежи и схемы',
        ],
      },
    ],
    variant: 'dark' as const,
    image: module2,
  },
  {
    number: 5,
    title: 'Свадебные торты. Декор',
    expandedTitle: 'Модуль «Декоры свадебных тортов»',
    description: '10 свадебных дизайнов\nс пошаговой сборкой',
    details: [
      { heading: 'Урок 1', text: 'торт «Нежные банты»' },
      { heading: 'Урок 2', text: 'торт «Корейский дизайн»' },
      { heading: 'Урок 3', text: 'торт «Неземные цветы»' },
      { heading: 'Урок 4', text: 'торт «Бусы»' },
      { heading: 'Урок 5', text: 'торт «Капуста»' },
      { heading: 'Урок 6', text: 'торт «Нежность»' },
      { heading: 'Урок 7', text: 'торт «Итальянский пирог»' },
      { heading: 'Урок 8', text: 'торт «Оригами»' },
      { heading: 'Урок 9', text: 'торт «Длинный»' },
      { heading: 'Урок 10', text: 'торт «Шторы»' },
    ],
    variant: 'light' as const,
    image: module1,
  },
  {
    number: 6,
    title: 'Упаковка\nи доставка',
    expandedTitle: 'Модуль «Упаковка и доставка»',
    description: 'Тайминги, замеры, упаковка, действия в нештатных ситуациях',
    details: [
      {
        heading: 'Урок 1',
        text: '«Как принимать заказы и правильно выдерживать тайминги» (также замер площадки, сроки, заказ машины и другие важные моменты)',
      },
      { heading: 'Урок 2', text: '« Упаковка свадебного торта»' },
      { heading: 'Урок 2', text: '«Важные моменты по работе с доставкой»' },
      {
        heading: 'Урок 3',
        text: '«Главные ошибки в работе – что делать если?»',
      },
    ],
    variant: 'dark' as const,
    image: module5,
  },
]

const FORMAT_CARDS = [
  {
    title: 'Уроки в записи',
    description: 'Смотрите в любое удобное время',
    image: formatLearning1,
  },
  {
    title: 'Постоянный доступ',
    description: 'Курс остаётся у вас навсегда',
    image: formatLearning2,
  },
  {
    title: 'Поддержка куратора',
    description: 'Помощь, проверка и поддержка',
    image: formatLearning3,
  },
]

const FAQ_ITEMS = [
  {
    question: 'Курс подойдёт новичкам или только опытным кондитерам?',
    answer:
      'Курс рассчитан на тех, кто уже имеет базовые кондитерские навыки. Все технические моменты работы с ярусниками (ганаш, мастика, опоры) мы разбираем с нуля и подробно.',
  },
  {
    question: 'А если у меня домашняя кухня и обычный холодильник?',
    answer:
      'Мы специально адаптировали все пропорции под стандартные домашние холодильники. Только последний бонус-урок (двухметровый торт) требует промышленных масштабов — он для вдохновения и понимания границ возможного.',
  },
  {
    question: 'Какое оборудование и инструменты понадобятся?',
    answer:
      'В курсе есть отдельная лекция про инвентарь: от обязательного минимума до того, что облегчает жизнь кондитеру. Всё это можно найти в обычных кондитерских магазинах, ничего уникального не требуется.',
  },
  {
    question: 'Как долго будет доступ к материалам?',
    answer:
      'Доступ остаётся навсегда. Вы можете пересматривать уроки в любое время, а также задавать вопросы куратору.',
  },
  {
    question: 'Входят ли в курс рецепты начинок?',
    answer:
      'Да, 8 фирменных начинок, которые мы используем в Pauline Cake. Все с видео и точными пропорциями.',
  },
  {
    question: 'Можно ли оплатить из другой страны?',
    answer: 'Да, принимаем карты РФ и зарубежные карты через платёжный сервис.',
  },
]

const CourseLanding = ({ onBuyClick }: CourseLandingProps) => {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null)
  const [openSolutionIndex, setOpenSolutionIndex] = useState<number | null>(
    null
  )
  const [openModuleIndex, setOpenModuleIndex] = useState<number | null>(null)
  const sectionRefs = useRef<Record<string, HTMLElement | null>>({})

  const scrollToSection = (id: string) => {
    sectionRefs.current[id]?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index)
  }

  return (
    <div className="cl-page">
      {/* === HERO === */}
      <section className="cl-hero">
        {/* Тёмный хедер-бар */}
        <div className="cl-hero-header">
          <img src={logo} alt="" className="cl-hero-logo" />
        </div>
        {/* Фото-блок с оверлеем */}
        <div
          className="cl-hero-photo"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="cl-hero-overlay">
            <div className="cl-hero-badge">Новая программа</div>
            <div className="cl-hero-title-block">
              <h1 className="cl-hero-title">СВАДЕБНЫЙ КУРС</h1>
              <p className="cl-hero-subtitle">от PAULINE CAKE</p>
            </div>
          </div>
          {/* Кнопка покупки — поверх нижней границы фото */}
          <button className="cl-hero-cta" onClick={onBuyClick}>
            КУПИТЬ КУРС
          </button>
        </div>
      </section>

      {/* === NAV === */}
      <section className="cl-nav">
        <div className="cl-nav-scroll">
          {NAV_ITEMS.map(item => (
            <button
              key={item.id}
              className="cl-nav-item"
              onClick={() => scrollToSection(item.id)}
            >
              <img
                src={item.image}
                alt={item.label}
                className="cl-nav-circle"
              />

              <span className="cl-nav-label">{item.label}</span>
            </button>
          ))}
        </div>
      </section>

      {/* === WEDDING CAKE TITLE === */}
      <section className="cl-wedding-title">
        <h2 className="cl-wedding-heading">WEDDING CAKE</h2>
        <p className="cl-wedding-desc">
          Курс по многоярусным тортам от Pauline Cake{'\n'}
          Полная система от начинок до сборки многоярусных тортов и трендовых
          декоров
        </p>
      </section>

      {/* === FOUNDER === */}
      <section
        className="cl-founder"
        ref={el => {
          sectionRefs.current['founder'] = el
        }}
      >
        <div className="cl-founder-card">
          <img src={ownerPhoto} alt="Основатель" className="cl-founder-photo" />
          <div className="cl-founder-logo">
            <span className="cl-section-label">Основатель</span>
            <img src={logoGray} alt="" />
          </div>
          <div className="cl-founder-text">
            <p>Привет, это Полина! </p>
            <p>
              Я кондитер с 12‑летним опытом, основатель Pauline Cake в Дубае, вы
              можете меня знать по популярным роликам из соцсетей.
            </p>
            <p>
              Один из моих лучших проектов, которым я безумно горжусь является
              SECRET CHAT — закрытое сообщество, где делюсь рецептами из нашего
              цеха, технологиями декора и стратегиями кондитерского бизнеса.
            </p>
          </div>
        </div>
      </section>

      {/* === DECORS === */}
      <section
        className="cl-decors"
        ref={el => {
          sectionRefs.current['results'] = el
        }}
      >
        <div className="cl-decors-title-block">
          <h3 className="cl-section-title">Декоры на свадебном курсе</h3>
          <img src={logoGray} alt="" className="cl-decors-logo" />
        </div>

        <div className="cl-decors-scroll">
          {DECORS.map((decor, idx) => (
            <div key={idx} className="cl-decor-card">
              <img
                src={decor.image}
                alt={decor.title}
                className="cl-decor-image"
              />
              <p className="cl-decor-name">{decor.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* === SOCIAL === */}
      <section className="cl-social">
        <div className="cl-social-top">
          <h3 className="cl-social-title">Социальные сети</h3>
          <img src={logoGray} alt="" className="cl-social-logo" />
        </div>
        <div className="cl-social-icons">
          <a
            href="https://www.instagram.com/pauline_secret_chat?igsh=aHc3YWVhYTRybXU1"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialSecret}
              alt="Secret Chat"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://telegram.me/+HE28136iRUA4MDEy"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialConditerka}
              alt="Кондитерка"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://www.instagram.com/pauline_wedding_course?igsh=MTl0ano3aml5dDEzcQ=="
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialWeddingIg}
              alt="Wedding Course IG"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://telegram.me/pauline_wedding_course"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialWeddingTg}
              alt="Wedding Course TG"
              className="cl-social-icon-img"
            />
          </a>
        </div>
      </section>

      {/* === MISSION === */}
      <section
        className="cl-mission"
        ref={el => {
          sectionRefs.current['mission'] = el
        }}
      >
        <div className="cl-mission-card">
          <img
            src={missionPhoto}
            alt="Основатель"
            className="cl-founder-photo"
          />
          <div className="cl-founder-logo">
            <span className="cl-section-label">Миссия свадебного курса</span>
            <img src={logoGray} alt="" />
          </div>
          <div className="cl-founder-text">
            <p>
              {' '}
              Я знаю, что многим страшно начинать заниматься свадебным из-за
              особой ответственности.{' '}
            </p>
            <p>
              И моя задача - дать вам систему и погрузить вас во все процессы,
              чтобы вы сами почувствовали контроль над свадебными тортами.
            </p>
            <p>
              Вы будете точно знать, какую начинку выбрать, как рассчитать
              пропорции под любой холодильник, как собрать надёжные опоры,
              идеально покрыть торт и украсить так, чтобы декор не отвалился по
              дороге. Всё, что мы наработали за годы работы в Pauline Cake, —
              для вашего спокойного и успешного свадебного сезона.
            </p>
          </div>
        </div>
      </section>

      {/* === AUDIENCE === */}
      {/* <section
        className="cl-audience"
        ref={el => {
          sectionRefs.current['audience'] = el
        }}
      >
        <h2 className="cl-audience-course-name">СВАДЕБНЫЙ КУРС</h2>

        <h3 className="cl-section-title">подойдёт вам, если вы:</h3>
        <div className="cl-audience-scroll">
          {AUDIENCE_CARDS.map((card, idx) => {
            const isOpen = openSolutionIndex === idx
            return (
              <div
                key={idx}
                className={`cl-audience-card cl-audience-card--${card.variant}`}
              >
                {isOpen ? (
                  <div className="cl-audience-solution-block">
                    <div
                      className="cl-audience-card-btn cl-audience-card-btn--active"
                      onClick={() => setOpenSolutionIndex(null)}
                    >
                      <MoveLeft size={14} />
                    </div>
                    <h4 className="cl-audience-solution-title">Решение</h4>
                    <p className="cl-audience-solution-text">{card.solution}</p>
                  </div>
                ) : (
                  <>
                    <div className="cl-audience-card-body">
                      <h4 className="cl-audience-card-title">{card.title}</h4>
                      <p className="cl-audience-card-desc">
                        {card.description}
                      </p>
                      <div
                        className="cl-audience-card-btn"
                        onClick={() => setOpenSolutionIndex(idx)}
                      >
                        <span>Решение</span>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )
          })}
        </div>
      </section> */}

      {/* === PROGRAM === */}
      <section
        className="cl-program"
        ref={el => {
          sectionRefs.current['program'] = el
        }}
      >
        <div className="cl-program-header">
          <span className="cl-program-label">Программа</span>
          <h2 className="cl-program-course-name">СВАДЕБНЫЙ КУРС</h2>
        </div>
        <div className="cl-program-scroll">
          {MODULES.map((mod, idx) => {
            const isOpen = openModuleIndex === idx
            return (
              <div
                key={mod.number}
                className={`cl-module-card cl-module-card--${mod.variant}${isOpen ? ' cl-module-card--open' : ''}`}
              >
                {isOpen ? (
                  <div className="cl-module-detail-block">
                    <div
                      className="cl-module-back-btn"
                      onClick={() => setOpenModuleIndex(null)}
                    >
                      <MoveLeft size={14} />
                    </div>
                    <h4 className="cl-module-detail-title">
                      {mod.expandedTitle}
                    </h4>
                    <div className="cl-module-detail-text">
                      {mod.details.map((section, i) => (
                        <div key={i} className="cl-module-detail-section">
                          <p>
                            <strong>{section.heading}</strong> {section.text}
                          </p>
                          {'bullets' in section && section.bullets && (
                            <ul className="cl-module-detail-bullets">
                              {section.bullets.map((item, j) => (
                                <li key={j}>{item}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="cl-module-card-block">
                      <div className="cl-module-badge">
                        <span>Модуль {mod.number}</span>
                      </div>
                      <h4 className="cl-module-title">{mod.title}</h4>
                      <p className="cl-module-desc">{mod.description}</p>
                    </div>
                    <img
                      src={mod.image}
                      alt={mod.title}
                      className="cl-module-image"
                    />
                    <div
                      className="cl-module-more"
                      onClick={() => setOpenModuleIndex(idx)}
                    >
                      <span>Подробнее</span>
                    </div>
                  </>
                )}
              </div>
            )
          })}
        </div>
      </section>

      {/* === PRICING === */}
      <section
        className="cl-pricing"
        ref={el => {
          sectionRefs.current['pricing'] = el
        }}
      >
        <h2 className="cl-pricing-label">Выбрать тариф</h2>
        <div className="cl-pricing-card">
          <div className="cl-pricing-prices">
            <span className="cl-pricing-new">29 900 ₽</span>
          </div>

          <button className="cl-pricing-cta" onClick={onBuyClick}>
            КУПИТЬ КУРС
          </button>
        </div>
      </section>

      {/* === FORMAT === */}
      <section
        className="cl-format"
        ref={el => {
          sectionRefs.current['format'] = el
        }}
      >
        <h2 className="cl-format-course-name">СВАДЕБНЫЙ КУРС</h2>
        <h3 className="cl-section-title">Формат обучения</h3>
        <div className="cl-format-scroll">
          {FORMAT_CARDS.map((card, idx) => (
            <div key={idx} className="cl-format-card">
              <img
                src={card.image}
                alt={card.title}
                className="cl-format-card-image"
              />
              <div className="cl-format-card-body">
                <h4 className="cl-format-card-title">{card.title}</h4>
                <p className="cl-format-card-desc">{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* === FAQ === */}
      <section
        className="cl-faq"
        ref={el => {
          sectionRefs.current['faq'] = el
        }}
      >
        <h2 className="cl-faq-label">FQA</h2>
        <h3 className="cl-section-title">Часто задаваемые вопросы</h3>
        <div className="cl-faq-list">
          {FAQ_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className={`cl-faq-item ${openFaqIndex === idx ? 'cl-faq-item--open' : ''}`}
              onClick={() => toggleFaq(idx)}
            >
              <div className="cl-faq-question">
                <span>{item.question}</span>
                <ChevronDown size={16} className="cl-faq-chevron" />
              </div>
              {openFaqIndex === idx && item.answer && (
                <div className="cl-faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* === FOOTER === */}
      <section className="cl-footer cl-social cl-footer-social-icons">
        <div className="cl-social-top">
          <h3 className="cl-social-title cl-footer-social-title">
            Социальные сети
          </h3>
          <img src={logoLight} alt="" className="cl-social-logo" />
        </div>
        <div className="cl-social-icons ">
          <a
            href="https://www.instagram.com/pauline_secret_chat?igsh=aHc3YWVhYTRybXU1"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialSecret}
              alt="Secret Chat"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://telegram.me/+HE28136iRUA4MDEy"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialConditerka}
              alt="Кондитерка"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://www.instagram.com/pauline_wedding_course?igsh=MTl0ano3aml5dDEzcQ=="
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialWeddingIg}
              alt="Wedding Course IG"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://telegram.me/pauline_wedding_course"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialWeddingTg}
              alt="Wedding Course TG"
              className="cl-social-icon-img"
            />
          </a>
        </div>
      </section>
    </div>
  )
}

export default CourseLanding
